<template>
  <div>
    <app-base-main
        parentTable
        style="padding: 12px 0 0;"
        table-border-top>
      <template #filter-group>
        <app-filter-group
            @query="$gjNoticeQuery"
            @reset="$gjReset">
          <gj-search-input
              v-model="filter.name"
              width="200px"
              placeholder="物流方式"
          ></gj-search-input>
          <gj-select
              v-model="filter.status"
              :options="HeadLogistics.base.statusOption"
              placeholder="状态"
          ></gj-select>
        </app-filter-group>
      </template>
      <template #operate-group>
        <gj-button
            v-if="$permission('transport:add/edit')"
            type="primary"
            @click="add(), temporarilyClosed()">
          添加
        </gj-button>
      </template>
      <template #tool-group>
        <gj-tool-group
            help
        ></gj-tool-group>
      </template>
      <template #table>
        <gj-table
            ref="gjTable"
            name="headLogisticsBase"
            :loading="loading"
            :data="tableData"
            :columns="columns"
            adapt-parent
            sortable="custom"
            :pagination="pagination"
            :default-sort="{prop: 'createTime', order: 'descending'}"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">

          <template v-slot:status="{row}">
            <gj-tag type="text" style="margin-right: 10px" shape="rectangle"
                    :color="row.status | optionColor(HeadLogistics.base.statusOption)">
              {{ row.status | optionText(HeadLogistics.base.statusOption) }}
            </gj-tag>
          </template>

          <template v-slot:op="{row}">
            <gj-button-group
                type="dropdown-op"
                :config="opBtnConfig(row)"
            ></gj-button-group>
          </template>
        </gj-table>
      </template>
    </app-base-main>
  </div>
</template>

<script>
  import {queryMixin, selectionMixin} from "@/minxins";
  import {defaultVal} from "@/utils/common";
  import AppOpHeadLogisticsModal from "../modal/op-head-logistics-modal";
  import {OpEnum} from "@/utils/options";
  import { deleteLogisticsTransport, getLogisticsTransportPage, updateLogisticsTransportStatus } from "@/api/logistics";
  import {HeadLogistics} from "../enum";
  import {mapGetters} from "vuex";

  export default {
    name: "app-head-logistics-base",
    mixins: [queryMixin, selectionMixin],
    inject: ["changeTab", "nextSteps", "temporarilyClosed", "cancelUserGuide"],
    computed: {
      ...mapGetters(['userGuideState'])
    },
    created() {
      this.sort.prop = 'createTime';
    },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'name', header: '物流方式', field: 'name', minWidth: '200px'},
          {id: 'chargeType', header: '计费类型', field: 'option:chargeType', minWidth: '150px', options: HeadLogistics.base.chargeTypeOption},
          {id: 'volumeWeightCoefficient', header: '体积重系数', field: 'volumeWeightCoefficient', minWidth: '120px', align: 'right'},
          {id: 'status', header: '状态', field: 'slot:status', minWidth: '120px', options: HeadLogistics.base.statusOption},
          {id: 'memo', header: '备注', field: 'memo', minWidth: '200px', overflowLine: 2},
          {id: 'createUserName', header: '创建人', field: 'createUserName', minWidth: '100px'},
          {id: 'createTime', header: '创建时间', field: 'createTime', minWidth: '200px', sortable: true},
          {id: 'updateTime', header: '更新时间', field: 'updateTime', minWidth: '200px', sortable: true},
          {id: 'op', header: '操作', field: 'slot:op', width: '120px', fixed: 'right', notCustomColumn: true},
        ],
        opBtnConfig: (row) => [
          {
            label: '编辑',
            show: () => this.$permission('transport:add/edit'),
            click: () => this.edit(row)
          },
          {
            label: '启用',
            show: () => this.$permission('transport:enable')
              && row.status === HeadLogistics.base.status.DISABLE,
            click: () => this.active([row])
          },
          {
            label: '停用',
            show: () => this.$permission('transport:enable')
              && row.status === HeadLogistics.base.status.ENABLE,
            click: () => this.inactive([row])
          },
          {
            label: '删除',
            show: () => this.$permission('transport:delete'),
            click: () => this.deleteItem([row])
          },
        ],
        filter: {
          name: null,
          status: null
        },
        // 手动指定需要获取请求的参数的缓存key, 为了解决刷新情况下拿不到嵌套路由正确的key问题，值为当前组件name
        filterStoragekey: 'app-head-logistics-base',
        HeadLogistics: HeadLogistics,
        notStorage: true
      }
    },
    methods: {
      $gjQueryInitParams() {
        return {
          filter: {
            name: null,
            status: null
          }
        };
      },
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            name: this.filter.name,
            status: defaultVal(this.filter.status),
          },
          ...this.queryPagination,
          ...this.querySort
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getLogisticsTransportPage(params)
          .then((data) => {
            this.tableData = data.records;
            this.pagination = this.getPagination(data);
          })
          .complete(() => this.loading = false);
      },
      viewLog() {
        this.$gjCreate('gj-log-modal', {
          props: {
            url: '/supply/brand/logPage',
            opTypeOption: [
              {id: 'Enable', text: '启用'},
              {id: 'Disable', text: '停用'},
              {id: 'Add', text: '添加'},
              {id: 'Delete', text: '删除'},
              {id: 'Update', text: '更新'},
            ]
          }
        });
      },
      add() {
        this.addModal = this.$gjCreate(AppOpHeadLogisticsModal, {
          props: {
            opType: OpEnum.type.ADD,
          },
          on: {
            created: () => {
              this.$gjMessage.success('添加成功');
              this.$gjResetPage();
              this.refreshStoreTransport();
              if(this.userGuideState) {
                this.autoClose = true
                this.changeTab('duration')
                this.nextSteps(2)
              }
              this.addModal.$gjDestroy();
            },
            close: () => {
              if(!this.autoClose && this.userGuideState) { // 手动关闭
                 // 关闭引导用户
                this.cancelUserGuide()
                this.autoClose = false
              }
              this.addModal = null;
            }
          },
        });
      },
      edit(item) {
        this.$gjCreate(AppOpHeadLogisticsModal, {
          props: {
            data: item,
            opType: OpEnum.type.UPDATE
          },
          on: {
            updated: () => {
              this.$gjMessage.success('更新成功');
              this.$gjResetPage();
              this.refreshStoreTransport();
            }
          },
        });
      },
      deleteItem(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '删除确认',
            content: rows.length === 1
              ? `确定要删除[${rows[0].name}]吗？一旦删除不可恢复，请谨慎操作！`
              : `已选中 ${rows.length} 个物流方式，确定要批量删除吗？一旦删除不可恢复，请谨慎操作！`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              deleteLogisticsTransport({
                ids: rows.map(e => e.id)
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                  this.refreshStoreTransport();
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      inactive(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '停用确认',
            content: rows.length === 1
              ? `确定要停用[${rows[0].name}]吗？`
              : `已选中 ${rows.length} 个物流方式，确定要批量停用吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              updateLogisticsTransportStatus({
                id: rows[0].id,
                status: HeadLogistics.base.status.DISABLE
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                  this.refreshStoreTransport();
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      active(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '启用确认',
            content: rows.length === 1
              ? `确定要启用[${rows[0].name}]吗？`
              : `已选中 ${rows.length} 个物流方式，确定要批量启用吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              updateLogisticsTransportStatus({
                id: rows[0].id,
                status: HeadLogistics.base.status.ENABLE
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                  this.refreshStoreTransport();
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      refreshStoreTransport() {

      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
